import { render, staticRenderFns } from "./InsureInfoDetail.vue?vue&type=template&id=3dea8f7c&scoped=true&"
import script from "./InsureInfoDetail.vue?vue&type=script&lang=js&"
export * from "./InsureInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./InsureInfoDetail.vue?vue&type=style&index=0&id=3dea8f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea8f7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dea8f7c')) {
      api.createRecord('3dea8f7c', component.options)
    } else {
      api.reload('3dea8f7c', component.options)
    }
    module.hot.accept("./InsureInfoDetail.vue?vue&type=template&id=3dea8f7c&scoped=true&", function () {
      api.rerender('3dea8f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/InsureInfoDetail.vue"
export default component.exports